import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import Onboarding from './components/Onboarding';
import ProfileSetup from './components/ProfileSetup';
import Welcome from './components/Welcome';
import './index.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import TermsAgreement from './pages/TermsAgreement';
import CreateAccount from './pages/CreateAccount';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ConsumerHealthDataPolicy from './pages/ConsumerHealthDataPolicy';
import GoogleAuthorize from './pages/GoogleAuthorize';
import { preloadWebLLMEngine } from './services/webllmService';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditingProfile, setIsEditingProfile] = useState(false);
  const [showWelcome, setShowWelcome] = useState(false);

  useEffect(() => {
    preloadWebLLMEngine();

    const authToken = localStorage.getItem('authToken');
    const savedUser = localStorage.getItem('user');
    const savedProfile = localStorage.getItem('userProfile');
    const hasSeenWelcome = localStorage.getItem('hasSeenWelcome');

    if (authToken && savedUser) {
      setIsAuthenticated(true);
      setUser(JSON.parse(savedUser));
      if (savedProfile) {
        setUserProfile(JSON.parse(savedProfile));
      }
    } else if (!hasSeenWelcome) {
      setShowWelcome(true);
    }
    setLoading(false);
  }, []);

  const handleLogin = (userData) => {
    setIsAuthenticated(true);
    setUser(userData);
    const savedProfile = localStorage.getItem('userProfile');
    if (savedProfile) {
      setUserProfile(JSON.parse(savedProfile));
    } else {
      setUserProfile(null);
    }
  };

  const handleOnboardingComplete = (profile) => {
    if (profile?.account) {
      setUser(profile.account);
    }
    setUserProfile(profile);
    localStorage.setItem('userProfile', JSON.stringify(profile));
    setIsEditingProfile(false);
  };

  const handleWelcomeComplete = () => {
    localStorage.setItem('hasSeenWelcome', 'true');
    setShowWelcome(false);
  };

  const handleProfileUpdate = () => {
    setIsEditingProfile(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    localStorage.removeItem('userProfile');
    setIsAuthenticated(false);
    setUser(null);
    setUserProfile(null);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (showWelcome) {
    return <Welcome onGetStarted={handleWelcomeComplete} />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/authorize" element={<GoogleAuthorize onLogin={handleLogin} />} />
        <Route path="/terms-agreement" element={<TermsAgreement />} />
        <Route path="/create-account" element={<CreateAccount />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/consumer-health-data-policy" element={<ConsumerHealthDataPolicy />} />
        <Route
          path="/*"
          element={
            !isAuthenticated ? (
              <Login onLogin={handleLogin} />
            ) : !userProfile ? (
              <ProfileSetup user={user} onComplete={handleOnboardingComplete} />
            ) : isEditingProfile ? (
              <Onboarding user={user} onComplete={handleOnboardingComplete} initialProfile={userProfile} />
            ) : (
              <Home
                user={user}
                userProfile={userProfile}
                onEditProfile={handleProfileUpdate}
                onLogout={handleLogout}
              />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
